import { render, staticRenderFns } from "./user-source-rate.vue?vue&type=template&id=2c86dfc0&scoped=true&"
import script from "./user-source-rate.vue?vue&type=script&lang=js&"
export * from "./user-source-rate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c86dfc0",
  null
  
)

export default component.exports